function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import BreadcrumbsBack from '../common/lookups/breadcrumbsBack';
import WeekEndingFilterOption from './weekEndingFilterOption';
const getWeekEndingOptions = startDate => {
  const weekEnding = [];
  let initialDate = startDate;
  if (initialDate) {
    // avoid duplicating date when creating next page by setting the initial date
    // to the prior week. In the loop beleow the first date added has 0 weeks subtracted
    initialDate = moment(startDate).subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
  }
  for (let i = 0; i < 10; i += 1) {
    const date = moment(initialDate).subtract(i, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
    const formattedDate = `${date} 23:59:59.0000`;
    weekEnding.push({
      entity: 'weekEnding',
      filter: 'weekEnding',
      nodes: [],
      id: formattedDate,
      name: date
    });
  }
  return weekEnding;
};
const WeekEndingFilter = props => {
  const {
    onBack,
    indexQuery,
    serverFilter
  } = props;
  const [scrollPos, setScrollPos] = useState(0);
  const [items, setItems] = useState(getWeekEndingOptions());
  const [selectedItems, setSelectedItems] = useState(indexQuery.filters.weekEnding || []);
  const onScroll = event => {
    const newPos = event.target.scrollTop;
    if (newPos !== 0) {
      setScrollPos(newPos);
    }
  };
  const pageNext = () => {
    const nextItems = getWeekEndingOptions(items[items.length - 1].id);
    setItems(items.concat(nextItems));
  };
  const handleWeekendingFilter = selection => {
    let updatedSelections = selectedItems;
    const existing = selectedItems.some(item => item.id === selection.id);
    if (existing) {
      updatedSelections = selectedItems.filter(item => item.id !== selection.id);
    } else {
      updatedSelections.push(selection);
    }
    setSelectedItems(updatedSelections);
    serverFilter(_objectSpread(_objectSpread({}, indexQuery.filters), {}, {
      weekEnding: updatedSelections
    }), indexQuery);
  };
  const isSelected = option => selectedItems.some(item => item.id === option.id);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, "Week Ending"), /*#__PURE__*/React.createElement(BreadcrumbsBack, {
    onBack: onBack,
    onSelect: onBack,
    backLabel: "Filters"
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    id: "weekending-scroll",
    style: {
      height: '250px',
      overflowX: 'scroll'
    },
    role: "scrollbar",
    "aria-controls": "weekending-scroll",
    "aria-valuenow": 0
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    dataLength: items.length || 0,
    next: pageNext,
    scrollableTarget: "weekending-scroll",
    style: {
      overflow: 'hidden'
    },
    initialScrollY: scrollPos,
    onScroll: onScroll,
    hasMore: true
  }, items.map(option => /*#__PURE__*/React.createElement(WeekEndingFilterOption, {
    key: option.id,
    option: option,
    onSelect: handleWeekendingFilter,
    selected: isSelected(option)
  })))));
};
WeekEndingFilter.propTypes = {
  onBack: PropTypes.func.isRequired,
  indexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      weekEnding: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }).isRequired,
  serverFilter: PropTypes.func.isRequired
};
export default WeekEndingFilter;